import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasTornillo/BombaTornillo1.png';
import Img2 from '../../img/products/bombas/BombasTornillo/BombaTornillo2.png';

const BombasMultietapas = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas de Tornillo</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2 flex-column">
            <div className="col-12">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom mb-2" alt="Bomba 1" />
            </div>
            <div className="col-12">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas de tornillo, también conocidas como bombas de tornillo excéntrico o bombas de cavidad
            progresiva, son un tipo de bomba de desplazamiento positivo que utilizan un tornillo helicoidal
            giratorio para mover fluidos.
          </p>
          <p className="lead text-justify">
            Estas bombas son ampliamente utilizadas en industrias donde se requiere el manejo de fluidos viscosos,
            abrasivos o con partículas sólidas.El elemento principal es un tornillo giratorio que encaja en una
            carcasa de caucho o metal, creando cavidades que se desplazan progresivamente desde la entrada hasta
            la salida de la bomba.
          </p>
          <p className="lead text-justify">
            Pueden manejar una amplia gama de fluidos, desde líquidos de baja viscosidad hasta pastas y lodos altamente viscosos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BombasMultietapas;
